import React from "react";
import config from "config";
import PropTypes from "prop-types";
import { IconStoreFront } from "../../components/Icons";
import { Icon, Typography } from "@plum-xoxo/admin-dsm";
import theme from "../../theme/theme";

class StoreFrontLink extends React.Component {
  render() {
    const { employeeDetails: { domain = "" } = {} } = this.props;
    const url = config.storeFrontURL.replace(/\/$/g, "");
    return (
      <a
        className="switch-store-linkX"
        target="_blank"
        href={`${url}/${domain}`}
      >
        <Typography component="div" className="d-flex">
          <Icon color="dark" shade="c200" iconName="PlumStorefront" size={16} />
          <Typography.LabelText
            id="header-account-dropdown-visit-storefront-link"
            component="div"
            color="dark"
            shade="c300"
            className="ml-16"
          >
            Visit Storefront
            <Typography.BodySmall component="div" color="dark" shade="c200">
              /{domain}
            </Typography.BodySmall>
          </Typography.LabelText>
        </Typography>
      </a>
    );
  }
}

export default StoreFrontLink;

StoreFrontLink.propTypes = {
  companyDetails: PropTypes.object.isRequired,
  employeeDetails: PropTypes.object.isRequired,
};
